<template>
	<div id="term02">
		<article>
			<div>					
				<h1>주식회사 데이터노우즈 개인정보 처리방침</h1>
				<p>주식회사 데이터노우즈 (이하 ‘회사’라 한다)는 개인정보 보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립/공개합니다.</p>
			
				<h3>1. 개인정보의 처리목적</h3>
					<p>회사는 다음의 목적을 위하여 개인정보를 처리합니다.</p>
					<p>처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>

					<p>1. 홈페이지 회원 가입 및 관리</p>
						<div class="indented">
							<p>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별/인증, 회원자격 유지․관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리시 법정대리인의 동의여부 확인, 각종 고지․통지,고충처리 등을 목적으로 개인정보를 처리합니다.</p>
						</div>							

					<p>2. 재화 또는 서비스 제공</p>
						<div class="indented">
							<p>물품배송, 서비스 제공, 계약서/청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제․정산, 채권추심 등을 목적으로 개인정보를 처리합니다.</p>								
						</div>

					<p>3. 고충처리</p>
						<div class="indented">								
							<p>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락/통지, 처리결과 통보등의 목적으로 개인정보를 처리합니다.</p>
						</div>							

				<h3>2. 개인정보의 처리 및 보유기간</h3>
					<p>① 회사는 법령에 따른 개인정보 보유/이용기간 또는 정보주체로부터 개인정보를 수집시에 동의받은 개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다.</p>
					<p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
						<div class="indented">
							<p>1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴시까지</p>
								<div class="indented">
									<p>다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지</p>										
									<p>1) 관계 법령 위반에 따른 수사/조사 등이 진행중인 경우에는 해당 수사/조사 종료시까지</p>										
									<p>2) 홈페이지 이용에 따른 채권/채무관계 잔존시에는 해당 채권/채무관계 정산시까지</p>
								</div>									
							<p>2. 재화 또는 서비스 제공 : 재화/서비스 공급완료 및 요금결제/정산 완료시까지</p>
								<div class="indented">																				
									<p>다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지</p>
									<p>1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시/광고, 계약내용 및 이행 등 거래에 관한 기록</p>
										<div class="indented">
											<p>- 표시/광고에 관한 기록 : 6월</p>
											<p>- 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년</p>
											<p>- 소비자 불만 또는 분쟁처리에 관한 기록 : 3년</p>
										</div>

									<p>2) 「통신비밀보호법」제41조에 따른 통신사실확인자료 보관</p>
										<div class="indented">
											<p>- 가입자 전기통신일시, 개시/종료시간, 상대방 가입자번호, 사용도수, 발신기지국 위치추적자료 : 1년</p>
											<p>- 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월</p>
										</div>									
								</div>																				
							</div>
				
				<h3>3. 개인정보의 제3자 제공</h3>
					<p>① 회사는 정보주체의 개인정보를 제1조(개인정보의처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한규정 등 개인정보 보호법 제17조에 해당하는 경우, 또는 정보주체가 사전에 동의한 경우에만 개인정보를 제3자에게 제공합니다.</p>

				<h3>4. 개인정보처리의 위탁</h3>
					<p>① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
						<div class="indented">
							<ol start="1">
								<li>이니시스 (주)
									<p>- 위탁업무 내용: 신용카드결제 (이용고객에한함)</p>
									<p>- 개인정보의 보유 및 이용기간: 업무목적 달성시 까지</p>
								</li>
							</ol>
							<ol start="2">
								<li>(주) 카카오페이
									<p>- 위탁업무 내용: 간편결제 (이용고객에한함)</p>
									<p>- 개인정보의 보유 및 이용기간: 업무 목적 달성시 까지</p>
								</li>
							</ol>
						</div>
					<p>② 회사는 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적/관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․ 감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
					<p>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>

				<h3>5. 정보주체의 권리/의무 및 행사방법</h3>
					<p>① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
						<div class="indented">
							<p>1. 개인정보 열람요구</p>
							<p>2. 오류 등이 있을 경우 정정 요구</p>
							<p>3. 삭제요구</p>
							<p>4. 처리정지 요구</p>
						</div>
					<p>② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 이메일 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.</p>
					<p>③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
					<p>④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
					<p>⑤ 정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니됩니다.</p>

				<h3>6. 처리하는 개인정보 항목</h3>
					<p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>
						<div class="indented">
							<p>1. 홈페이지 회원 가입 및 관리</p>
								<div class="indented">
									<p>․필수항목 : SNS계정 로그인을 위한 OAuth 정보 (아이디 일련번호), 이메일주소, 핸드폰 번호</p>
								</div>
							<p>2. 재화 또는 서비스 제공</p>
								<div class="indented">
									<p>․필수항목 : 성명, 생년월일, 전화번호, 이메일주소, 신용카드번호, 은행계좌정보 등 결제정보</p>							
									<p>․선택항목 : 관심분야, 과거 구매내역</p>
								</div>
							<p>3. 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.</p>
								<div class="indented">
									<p>- IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등</p>
								</div>
						</div>

				<h3>7. 개인정보의 파기</h3>
					<p> ① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
					<p>② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>
					<p>③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
						<div class="indented">
							<p>1. 파기절차</p>
								<div class="indented">
									<p>회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>
								</div>
							<p>2. 파기방법</p>
								<div class="indented">
									<p>회사는 전자적 파일 형태로 기록/저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>																		
								</div>								
						</div>

				<h3>8. 개인정보의 안전성 확보조치</h3>
					<p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
						<div class="indented">
							<p>1. 관리적 조치 : 내부관리계획 수립/시행, 정기적 직원 교육 등</p>
							<p>2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 암호화 통신, 비밀번호 암호화</p>							
						</div>

				<h3>9. 개인정보 보호책임자</h3>				
					<p>① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
						<div class="indented">
							<p>▶ 개인정보 보호책임자</p>
								<div class="indented">
									<p>성명 : 박진성</p>
									<p>직책 : 팀장</p>									
									<p>연락처 : jin@dataknows.ai</p>
								</div>
						</div>
					<p>② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.</p>
					<p>기타 개인정보침해에 대한 신고나 상담이 필요한 경우 아래 기관에 문의할 수 있습니다.</p>
						<div class="indented">
							<p>- 개인정보 침해신고센터 (한국인터넷진흥원 운영) (http://privacy.kisa.or.kr / 국번없이 118)</p>
							<p>- 개인정보 분쟁조정위원회 (http://www.kopico.go.kr / 국번없이 1833-6972)</p>
							<p>- 대검찰성 사이버수사과 (http://www.spo.go.kr / 국번없이 1301)</p>
							<p>- 경찰성 사이버안전국 (http://cyberbureau.police.go.kr / 국번없이 182)</p>
						</div>

				<h3>10. 개인정보 처리방침 변경</h3>
					<p>현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지 &#x27;공지사항&#x27;을 통해 고지합니다.</p>
					<p>다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일전에 고지합니다.</p>
					<p>- 공고일자 : 2018-08-19</p>
					<p>- 시행일자 : 2019-08-29</p>
			</div>
		</article>        
	</div>    
</template>

<script>
export default {
    
}
</script>

<style scoped>
#term02 {
  text-align: left;
  margin-left: 2rem;
  margin-right: 2rem;
}

a,
a.visited {
	color: inherit;
	text-decoration: underline;
}

h1,
h2,
h3 {
	letter-spacing: -0.01em;
	line-height: 1.2;
	font-weight: 600;
	margin-bottom: 0;
}

h1 {
	font-size: 1.875rem;
	margin-top: 1.875rem;
}

h2 {
	font-size: 1.5rem;
	margin-top: 1.5rem;
}

h3 {
	font-size: 1.25rem;
	margin-top: 1.25rem;
}

.indented {
	padding-left: 1.5em;
}
</style>